<template>
  <div class="center-text font-bold desktop-only">How it Works:</div>
  
  <div class="container mobile-grid-section">
    <div class="vertical-line first"></div>
    <div class="vertical-line second"></div>
    <div class="horizontal-line top"></div>
    <div class="horizontal-line bottom"></div>

    <div class="content-block">
      <div class="inner-content">
        <h1 class="number font-light">1</h1>
        <p class="description font-regular">
          Set your password preferences<br />
          like length, complexity,<br />
          and character types
        </p>
      </div>
    </div>

    <div class="content-block2">
      <div class="inner-content">
        <h1 class="number font-light">2</h1>
        <p class="description font-regular">
          Get a secure password <br />
          right away—copy it or <br />
          refresh for a new one
        </p>
      </div>
    </div>

    <div class="content-block3">
      <div class="inner-content">
        <h1 class="number font-light">3</h1>
        <p class="description font-regular">
          Tap to instantly create a new<br />
          password whenever you need <br />
          it
        </p>
      </div>
    </div>
  </div>

  <div class="center-text2 font-semibold">
    Keep Passwords Organized
  </div>

  <div class="container mobile-grid-section organized-section">
    <div class="gradient-overlay"></div>
    <div class="vertical-line2 first"></div>
    <div class="vertical-line2 second"></div>
    <div class="horizontal-line top2"></div>
    <div class="horizontal-line bottom2"></div>

    <div class="mobile-row row-1">
      <div class="image-container-medium">
        <img src="@/assets/passwordStorage.webp" alt="Password's Storage" loading="lazy" width="556" height="1203" />
      </div>
      <div class="content-block4">
        <p class="description font-light">
          Sort passwords into folders <br />
          for quick and easy access. 
        </p>
      </div>
    </div>

    <div class="mobile-row row-2">
      <div class="content-block-small">
        <p class="small-description font-light">
          Create a folder and store <br />
          the passwords you need
        </p>
      </div>
      <div class="image-container-small">
        <img src="@/assets/createFolder.webp" alt="Create Folder" loading="lazy" width="492" height="1065" />
      </div>
    </div>
  </div>

  <div class="center-text3 font-semibold">
    Add Extra Security with <br />
    Multi-Factor Authentication
  </div> 

  <div class="container mobile-grid-section mfa-section">
    <div class="vertical-line3 first"></div>
    <div class="vertical-line3 second"></div>
    <div class="horizontal-line top3"></div>
    <div class="horizontal-line bottom3"></div>

    <div class="mfa-group">
      <div class="content-block mfa-text-block">
        <h1 class="number font-light">1</h1>
        <p class="description font-regular">
          Open the Settings by tapping<br />
          the icon and select Multi-Factor<br />
          Authentication
        </p>
      </div>
      <div class="image-container mfa-img-block">
        <img src="@/assets/mfa.webp" alt="Step 1 Image" loading="lazy" width="556" height="1206" />
      </div>
    </div>

    <div class="mfa-group">
      <div class="content-block2 mfa-text-block">
        <h1 class="number font-light">2</h1>
        <p class="description font-regular">
          Open your authenticator <br />
          app, where a 6-digit code <br />
          will be displayed.
        </p>
      </div>
      <div class="image-container2 mfa-img-block">
        <img src="@/assets/mfa2.webp" alt="Step 2 Image" loading="lazy" width="556" height="1206" />
      </div>
    </div>

    <div class="mfa-group last">
      <div class="content-block3 mfa-text-block">
        <h1 class="number font-light">3</h1>
        <p class="description font-regular">
          Complete the setup and <br />
          enjoy enhanced security with <br />
          each login
        </p>
      </div>
      <div class="image-container3 mfa-img-block">
        <img src="@/assets/mfa3.webp" alt="Step 3 Image" loading="lazy" width="556" height="1206" />
      </div>
    </div>
  </div>

  <footer class="footer font-light">
    © 2026 Sequreio App. All Rights Reserved.
  </footer>
</template>

<script>
export default {
  name: 'DescriptionComponent'
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Albert+Sans:wght@300;400;500;700&display=swap');
</style>

<style scoped>
/* ========================================= */
/* DESKTOP STYLES (UPDATED)                  */
/* ========================================= */
.font-light { font-family: 'Albert Sans', sans-serif; font-weight: 300; }
.font-regular { font-family: 'Albert Sans', sans-serif; font-weight: 400; }
.font-semibold { font-family: 'Albert Sans', sans-serif; font-weight: 500; }
.font-bold { font-family: 'Albert Sans', sans-serif; font-weight: 700; }

.mobile-only { display: none; } 

.gradient-overlay {
  position: absolute; width: 261px; height: 345px;
  background: linear-gradient(-35deg, rgba(18, 229, 90, 0.5) 0%, rgba(25, 43, 156, 0.5) 100%);
  filter: blur(200px); top: 70%; left: 50%;
  transform: translate(-50%, -50%) rotate(35deg); z-index: 0;
}

/* Titles */
.center-text, .center-text2 {
  display: flex; justify-content: center; align-items: center;
  color: rgba(205, 207, 207, 0.9);
}
.center-text { font-size: 26px; margin-bottom: 20px; }
.center-text2 { font-size: 40px; margin-bottom: 80px; }
.center-text3 {
  display: flex; justify-content: center; align-items: center; text-align: center; 
  font-size: 40px; color: rgba(205, 207, 207, 0.9); margin-top: 275px; margin-bottom: 80px; line-height: 75px;
}

/* Container */
.container {
  position: relative; width: 100%; max-width: 1200px; height: 500px;
  margin: 0 auto; background-color: #161616; box-sizing: border-box;
}

/* Desktop Lines */
.vertical-line, .vertical-line2, .vertical-line3, .horizontal-line {
  position: absolute; background-color: rgba(255, 255, 255, 0.15);
}
.vertical-line { height: 70%; width: 1px; }
.vertical-line2 { height: 650px; width: 1px; }
.vertical-line3 { height: 1049px; width: 1px; }
.first { left: 33%; transform: translateX(-50%); }
.second { right: 33%; }
.horizontal-line { width: 100%; height: 1px; }
.top { top: calc(50% - 225px); }
.top2 { top: 35% }
.top3 { top: 15% }
.bottom { top: 325px; }
.bottom2 { bottom: 5%; }
.bottom3 { top: calc(50% + 725px); }

/* --- FIX: UPDATED DESKTOP BLOCKS --- */
/* This fixes the alignment of the 1, 2, 3 sections into their proper columns */

/* 1. Ensure inner content is flex on Desktop too (fixes description dropping to next row) */
.inner-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* 2. Position Block 1 in the First Column (0-33%) */
.content-block {
  position: absolute; 
  top: 35%; 
  transform: translateY(-50%); 
  display: flex; 
  align-items: center; 
  
  /* Adjusted Positioning */
  left: 0;
  width: 33.33%; /* Fill the first column */
  justify-content: center; /* Center content within column */
  padding-left: 0; 
}

/* 3. Position Block 2 in the Second Column (33-66%) */
.content-block2 {
  position: absolute; 
  top: 35%; 
  transform: translateY(-50%); 
  display: flex; 
  align-items: center; 
  
  /* Adjusted Positioning */
  left: 33.33%;
  width: 33.33%;
  justify-content: center;
  padding-left: 0;
}

/* 4. Position Block 3 in the Third Column (66-100%) */
.content-block3 {
  position: absolute; 
  top: 35%; 
  transform: translateY(-50%); 
  display: flex; 
  align-items: center; 
  
  /* Adjusted Positioning */
  left: 66.66%;
  width: 33.33%;
  justify-content: center;
  padding-left: 0;
}

/* Organized & MFA Section Images */
.content-block4 { position: absolute; top: 80%; left: 10%; transform: translateY(-50%); display: flex; align-items: center; }
.content-block-small { position: absolute; top: 10%; left: 74%; transform: translateY(-50%); display: flex; align-items: center; }

.number { font-size: 150px; font-weight: 300; color: rgba(255, 255, 255, 0.15); margin: 0; line-height: 1; }
.description, .small-description {
  font-size: 20px; font-weight: 400; color: rgba(255, 255, 255, 0.7); margin: 0; max-width: 300px; line-height: 1.6;
}

.image-container, .image-container2, .image-container3, .image-container-medium, .image-container-small {
  display: flex; justify-content: center; align-items: center; position: absolute;
}
/* Aligned images to match columns roughly */
.image-container { top: 60%; left: 4%; }
.image-container2 { top: 60%; left: 39%; }
.image-container3 { top: 60%; left: 74%; }
.image-container-small { top: 25%; left: 74%; }
.image-container-medium { top: 11%; left: 39%; }

.image-container img, .image-container2 img, .image-container3 img, .image-container-medium img {
  width: 278px; height: 603px; object-fit: cover; border-radius: 8px;
}
.image-container-small img { width: 246px; height: 532px; object-fit: cover; border-radius: 8px; }

.footer {
  display: flex; justify-content: center; align-items: center;
  font-size: 16px; color: rgba(205, 207, 207, 0.9);
  padding: 20px 0; margin-top: 500px; background-color: #161616; width: 100%; line-height: 24px;
}

/* ======================================================= */
/* MOBILE TRANSFORMATION (MAX-WIDTH: 767px)                */
/* ======================================================= */
@media (max-width: 767px) {
  
  /* --- UTILS --- */
  .desktop-only { display: none !important; }
  .mobile-only { display: block !important; }
  
  /* Reset Desktop Positions */
  .vertical-line, .horizontal-line, .first, .second, .top, .bottom,
  .vertical-line2, .horizontal-line2, .top2, .bottom2,
  .vertical-line3, .horizontal-line3, .top3, .bottom3 {
    display: none !important;
  }

  /* --- HERO TITLE --- */
  .hero-title {
    font-family: 'Albert Sans', sans-serif;
    font-weight: 300;
    font-size: 40px;
    line-height: 1.5;
    text-align: center;
    color: rgba(225, 226, 230, 0.9);
    margin: 40px 0 60px 0;
  }

  /* --- SECTION TITLES --- */
  .center-text2 { margin-top: 80px !important; margin-bottom: 40px !important; font-size: 20px; line-height: 1.4; text-align: center; }
  .center-text3 { font-size: 20px; line-height: 1.5; margin-top: 80px; margin-bottom: 40px; }

  /* --- UNIFIED GRID SYSTEM (BREAKOUT) --- */
  /* This class is applied to ALL container divs on mobile */
  .mobile-grid-section {
    position: relative;
    height: auto !important;
    display: flex;
    flex-direction: column;
    
    /* 100vw Width + 8px Margin Logic */
    width: 100vw !important;
    margin-left: -50vw !important;
    margin-right: -50vw !important;
    left: 50% !important;
    right: 50% !important;
    
    padding: 0 !important;
    border: none !important;
    overflow: visible !important;
    background: transparent;
  }

  /* Vertical Lines (8px from edge) */
  .mobile-grid-section::before,
  .mobile-grid-section::after {
    content: ''; position: absolute; width: 1px; background-color: rgba(255, 255, 255, 0.2);
    top: -30px; bottom: -30px; z-index: 0;
  }
  .mobile-grid-section::before { left: 8px !important; }
  .mobile-grid-section::after { right: 8px !important; }

  .mobile-grid-section .content-block, 
  .mobile-grid-section .content-block2, 
  .mobile-grid-section .content-block3 {
    position: relative !important; 
    top: auto !important; 
    
    /* CRITICAL FIX: Forces all blocks (especially #2) to the start of the line */
    left: 0 !important; 
    right: auto !important;
    transform: none !important;
    
    width: 100% !important; 
    margin: 0;
    
    /* Aligns the Number and Text to the left side */
    justify-content: flex-start !important; 
    
    /* Consistent spacing from the left edge */
    padding: 35px 20px !important; 
  }
  
  /* Horizontal Lines */
  .mobile-grid-section .content-block::after,
  .mobile-grid-section .content-block2::after,
  .mobile-grid-section .content-block3::after {
    content: ''; position: absolute; bottom: 0; height: 1px; background-color: rgba(255, 255, 255, 0.2);
    width: 100%; left: 0; z-index: 0;
  }
  .mobile-grid-section .content-block::before {
    content: ''; position: absolute; top: 0; height: 1px; background-color: rgba(255, 255, 255, 0.2);
    width: 100%; left: 0; z-index: 0;
  }
  
  .mobile-grid-section .number { 
    font-family: 'Albert Sans', sans-serif;
    font-weight: 300;
    font-style: normal;
    
    /* NEW SPECS */
    font-size: 120px !important; 
    line-height: 170% !important; 
    letter-spacing: 0;
    text-align: center;
    
    color: #4A4A4A !important; 
    min-width: 100px; /* Ensure number has space */
  }

  .inner-content { 
    display: flex; 
    align-items: center; 
    gap: 30px; /* Increased gap for better look with big numbers */
    z-index: 1; 
  }

/* --- SECTION 2: ORGANIZED --- */
  .organized-section .mobile-row {
    position: relative; width: 100%; padding: 30px 20px;
    display: flex; align-items: center; justify-content: space-between; gap: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }
  .organized-section .mobile-row.row-1 { border-top: 1px solid rgba(255, 255, 255, 0.2); }
  
  /* Flex Wrappers */
  .mobile-wrapper-row-1, .mobile-wrapper-row-2 { display: flex; width: 100%; align-items: center; justify-content: space-between; gap: 10px; }

  /* FIX 1: BIGGER IMAGE */
  .organized-section img { 
    width: 190px !important; /* Increased size */
    height: auto !important; 
    max-width: 50vw; /* Safety: prevents pushing text off screen */
    object-fit: contain;
  }

  /* FIX 2: VISIBLE GRADIENT */
  .organized-section .gradient-overlay { 
    width: 100%; 
    height: 100%; 
    top: 0; 
    left: 0; 
    transform: none; 
    /* Increased visibility settings */
    filter: blur(90px); 
    opacity: 0.8; /* Made brighter */
    z-index: -1;
    position: absolute;
  }

  /* Reset Elements */
  .organized-section .content-block4,
  .organized-section .content-block-small,
  .organized-section .image-container-medium,
  .organized-section .image-container-small {
    position: static !important; transform: none !important; width: auto !important; margin: 0 !important; display: block;
  }
  
  /* --- SECTION 3: MFA (Vertical Stack) --- */
  /* Reset MFA Elements */
  .mfa-section .mfa-group {
    display: flex; flex-direction: column; width: 100%;
  }

  .mfa-section .mfa-text-block,
  .mfa-section .mfa-img-block {
    position: static !important; top: auto; left: auto; transform: none;
    width: 100% !important; margin: 0; padding: 0 !important;
  }

  /* Step Text */
  .mfa-section .mfa-text-block {
    display: flex; flex-direction: row; align-items: center; gap: 20px;
    padding: 35px 20px !important;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  /* Step Image */
  .mfa-section .mfa-img-block {
    padding: 0 20px 40px 20px !important; /* Padding bottom for spacing */
    display: flex; justify-content: center;
    border-bottom: none; /* No border here, border is on the next text block */
  }

  .mfa-section .mfa-img-block img {
    width: 180px !important; /* Adjust MFA phone size */
    height: auto !important;
  }

  /* Remove description max-width for all mobile sections */
  .description, .small-description {
    font-size: 16px !important; line-height: 1.5 !important; color: #D1D1D1 !important; text-align: left; max-width: 100% !important;
  }
  
  .footer { margin-top: 60px; font-size: 12px; }
}
</style>